module.exports = __webpack_public_path__ + "img/bioconnect_dark.d4ddc3b5.svg";